import clsx from 'clsx';

export function UnreadBadge({ unreadCount }: { unreadCount?: number }) {
  if (!unreadCount || unreadCount < 0) return null;

  const unreadCountToDisplay = unreadCount > 9 ? '9+' : unreadCount;

  return (
    <span
      role="tooltip"
      aria-label={`${unreadCountToDisplay} unread notifications`}
      className={clsx(
        'bg-red-default',
        'text-white',
        'rounded-xl',
        'absolute',
        'left-6',
        'flex',
        'items-center',
        'justify-center',
        'text-xxsmall',
        'border',
        'border-white',
        'box-content',
        unreadCount > 9 ? 'top-1' : 'top-2',
        unreadCount > 9 ? 'w-5' : 'w-4',
        unreadCount > 9 ? 'h-5' : 'h-4',
      )}
    >
      {unreadCountToDisplay}
    </span>
  );
}
